import { FutureSettingsVersionDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useFutureCompanySettingsVersion = () => {
  const [futureCompanySettingsVersion, { loading }] = useMutation(FutureSettingsVersionDocument, {
    extractorFn: (data) => data.attendanceMutations.futureAttendanceCompanySettingsVersion,
  })

  const futureSettingVersion = () => {
    return futureCompanySettingsVersion({ variables: {} })
  }

  return {
    loading,
    futureSettingVersion,
  }
}
